export default __webpack_public_path__ + "static/media/contact_empty.2579b8b5.svg";